import { svgs } from './svgDefinitions';

const DiarySvg = ({ name, color }) => {
    const SvgComponent = svgs[name];
    if (!SvgComponent) return null;

    return SvgComponent(color);
};

export default DiarySvg;
